module.exports = __webpack_public_path__ + "img/designs-1680.e7442a7.png";